import React, { Component } from 'react';
import firebase from '../firebase-menumaker'
import {get} from 'lodash'
import makeCloudinaryUrlForPhoto from '../utils/makeCloudinaryUrlForPhoto'
import {StorageContext} from './MenuMaker'

class MenuLibrary extends Component {
  state = {
    show: false
  }
  render() {
    // let categories = this.props.categories
    let categories = get(this.props.menu, 'subMenus', [])
    let logo = get(this.props.menu, 'logo', {})

    return(
      <StorageContext.Consumer>
        {({handleAddPhoto}) => (
          <div className="library no-print">
            <header>
              <h2>Menu Library</h2>
              <button onClick={() => {this.setState({ show: !this.state.show })}}>Show/Hide</button>
            </header>
            {this.state.show && <section className="library__content">
              {logo.id && <div>
                <img src={makeCloudinaryUrlForPhoto(logo, {width: 100})} alt=""/>
                <button onClick={handleAddPhoto.bind(this, logo)}>add logo</button>
              </div>}
              <ul>
                {categories.map(category => {
                  return(
                    <Category {...category} key={category.id}></Category>
                  )
                })}
              </ul>
            </section>}
          </div>
        )}
      </StorageContext.Consumer>

    )
  }
}

class Category extends Component {
  render() {
    const name = get(this.props, 'name.en', '')
    const items = get(this.props, 'products', [])
    const description = get(this.props, 'description.en', '')
    return(
      <StorageContext.Consumer>
         {({handleAddTextList, handleAddHeaderBlock}) => (
        <li>
          <header><h2 className="library__title">{name}</h2>
          <button onClick={handleAddTextList.bind(this, this.props.id)}>TXT List</button>
          <button onClick={handleAddHeaderBlock.bind(this, {title: name, description })}>Add Header</button>
          </header>
          <ul>
            {items.map((i) => {
              return(
                <LibraryDish {...i} key={i.id}></LibraryDish>
              )
            })}
          </ul>
        </li>
         )}
      </StorageContext.Consumer>
    )
  }
}

class LibraryDish extends Component {
  render() {

    let name = get(this.props, 'name.en')
    let draft = get(this.props, 'draft')
    let photo = get(this.props, 'photo')
    

    return(
      <StorageContext.Consumer>
        {({handleAddDish, handleAddTextDish, handleAddImageDish}) => {
          return(<li>
           
            <button onClick={handleAddDish.bind(this, this.props.id)}>G</button>
            <button onClick={handleAddTextDish.bind(this, this.props.id)}>TXT</button>
            <button onClick={handleAddImageDish.bind(this, this.props.id)}>IMG{photo ? '' : ' ∅'}</button>


            {name}
            {draft && '(drafted)'}
          </li>)
        }}
      </StorageContext.Consumer>
    )
  }
}

export default (MenuLibrary)
